import Map from "./components/Map.vue";
import Marker from "./components/Marker.vue";

export function vmap(app)
{
	app.component("VmapMap", Map);
	app.component("VmapMarker", Marker);
}

export * from "./modules/geo.js";
export * from "./modules/src.js";
